import BlogPost from '@interfaces/post'
import BlogCard from '@comp/blog/blog-card'
import Container from '@comp/ui/container'
import Eyebrow from '@comp/ui/eyebrow'
import Heading from '@comp/ui/heading'

interface RelatedArticlesProps {
  locale: string
  posts: BlogPost[]
}

export default function RelatedArticles({ locale, posts }: RelatedArticlesProps) {
  if (!posts.length) return null

  return (
    <section className="border-t border-line-subtle bg-surface-subtle py-16 lg:py-24">
      <Container size="xl">
        <Eyebrow tone="brand">Keep reading</Eyebrow>
        <Heading as="h2" size="display-md" className="mt-4">
          Related articles
        </Heading>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post) => (
            <BlogCard key={post.slug} locale={locale} post={post} />
          ))}
        </div>
      </Container>
    </section>
  )
}
